import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const MemberImportApi = {
  /**
   * Fetch a list of all imports
   * @returns {Promise.<Array>}
   */
  index() {
    return http.get(`${orgPath()}/travelers/imports`).then((response) => response.data.data);
  },

  /**
   * Create a new member import
   * @param {Object} data - actual CSV file and dry_run flag
   * @param {Function} progressFn - callback function for handling upload progress updates
   * @returns {Promise.<Object>}
   */
  store(data, progressFn) {
    return http
      .post(`${orgPath()}/travelers/imports/upload`, data, { onUploadProgress: progressFn })
      .then((response) => response.data.data);
  },

  /**
   * Start processing a particular import
   * @param {String} id - import id
   * @returns {Promise.<Object>}
   */
  confirm(id) {
    return http.post(`${orgPath()}/travelers/imports/${id}/process`).then((response) => response.data.data);
  },

  /**
   * Fetch the details of a particular import
   * @param {String} id - import id
   * @returns {Promise.<Object>}
   */
  show(id) {
    return http.get(`${orgPath()}/travelers/imports/${id}`).then((response) => response.data.data);
  },

  /**
   * Restart an import with a new CSV file
   * @param {String} id - import id
   * @param {Object} data - actual CSV file and dry_run flag
   * @param {Function} progressFn - callback function for handling upload progress updates
   * @returns {Promise.<Object>}
   */
  update(id, data, progressFn) {
    return http
      .post(`${orgPath()}/travelers/imports/${id}/upload`, data, { onUploadProgress: progressFn })
      .then((response) => response.data.data);
  },
};
